import { render } from "./StammdatenDisplay.vue?vue&type=template&id=53d4be88&scoped=true"
import script from "./StammdatenDisplay.vue?vue&type=script&lang=js"
export * from "./StammdatenDisplay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d4be88"]])

export default __exports__